import { Component, OnInit, Input, ViewChild, Output, EventEmitter, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../Library/BaseComponent';
import { MasterDataService } from '../../Services/MasterDataService';
import { NgbModal, NgbActiveModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ChangePasswordRequest } from '../../Models/RequestModels';
import { UserService } from '../../Services/UserService';
import { APIServiceConnector } from '../../Services/APIServiceConnector';
import { AppSettings } from '../../Library/AppSettings';
@Component({
    selector: 'Configuration',
    templateUrl: './Configuration.html',
})

export class Configuration extends BaseComponent implements OnInit {
    @ViewChild('content') content;
    @ViewChild('ConfigURLText') ConfigURLText: ElementRef;
    ModalRef: NgbModalRef;
    Model: any;
    DisableModalOpenEvent: boolean = false;
    ConfigURL: string;
    RedirectConfigHTML: string;
    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, public modalService: NgbModal, protected userService: UserService,public apiService: APIServiceConnector) {
        super(translate, toastr, route, router, masterService);

    }
    ngOnInit(): void {
        this.RedirectConfigHTML = AppSettings.URL_PlatformConfigHTML;
    }

    Open(): void {
        this.ConfigURL = AppSettings.URL_Config.replace("{token}", this.apiService.getSessionCookie());
        if (this.DisableModalOpenEvent) return;
        this.Model = {};
        let ngbModalOptions: NgbModalOptions = {
            backdrop : 'static',
            centered: true
        };
        this.ModalRef = this.modalService.open(this.content, ngbModalOptions);
        this.DisableModalOpenEvent = true;
        this.ModalRef.result.then((result) => {
        }, (reason) => {
            this.DisableModalOpenEvent = false;
        });
    }

    RedirectNewConfig() {
        window.open(this.RedirectConfigHTML, "_blank");
    }
    OnSubmit(inputElement): void {

        let selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = this.ConfigURL;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
        this.GetMultilingualToast('TS.TS_URL_COPIED', 'success');

    }


}
